import React from 'react';
import { Card, Skeleton, Typography } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import * as LucideIcons from 'lucide-react';

const { Text } = Typography;

export interface StatCardProps {
    title: string;
    value: string | number;
    trend: string;
    trendType: 'up' | 'down' | 'warning';
    icon: string; // lucide icon name
    iconColor: string;
    loading?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
    title,
    value,
    trend,
    trendType,
    icon,
    iconColor,
    loading = false,
}) => {
    // 动态获取 lucide 图标
    const IconComponent = (LucideIcons as any)[
        icon.charAt(0).toUpperCase() + icon.slice(1).replace(/-([a-z])/g, (g) => g[1].toUpperCase())
    ] || LucideIcons.HelpCircle;

    const getTrendColor = () => {
        switch (trendType) {
            case 'up':
                return '#16A34A'; // 绿色
            case 'down':
                return '#EF4444'; // 红色
            case 'warning':
                return '#F59E0B'; // 警告橙
            default:
                return '#71717A';
        }
    };

    const trendIcon = trendType === 'up' ? <ArrowUpOutlined style={{ fontSize: 12 }} />
        : trendType === 'down' ? <ArrowDownOutlined style={{ fontSize: 12 }} /> : null;

    return (
        <Card variant="borderless" styles={{ body: { padding: '20px 24px' } }} style={{ borderRadius: 12, boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
            <Skeleton loading={loading} active paragraph={{ rows: 1 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text type="secondary" style={{ fontSize: 14 }}>{title}</Text>
                        <div style={{ padding: 8, background: `${iconColor}15`, borderRadius: '50%', display: 'flex' }}>
                            <IconComponent size={20} color={iconColor} strokeWidth={2} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <span style={{ fontSize: 28, fontWeight: 600, color: '#18181B', lineHeight: 1 }}>{value}</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
                            <span style={{ color: getTrendColor(), fontSize: 13, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 2 }}>
                                {trendIcon}
                                {trend}
                            </span>
                            <Text type="secondary" style={{ fontSize: 13 }}>较上个周期</Text>
                        </div>
                    </div>
                </div>
            </Skeleton>
        </Card>
    );
};

export default StatCard;
